import React, { type ComponentProps } from 'react';
import { Scrollspy, useContainerSpacing, useResponsive } from '@sg/garnish';

import { useA11ySelector } from '@order/utils';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoriesGridNav = (
  props: MenuCategoriesGridContainerProps,
) => {
  const { children, ...restProps } = props;

  const a11ySelector = useA11ySelector('menu.nav');

  const { currentBreakpoint } = useResponsive();
  const containerSpacing = useContainerSpacing();

  return (
    <Scrollspy.Nav
      stagePadding={currentBreakpoint.isLG ? undefined : containerSpacing}
      {...a11ySelector.props}
      {...restProps}
    >
      {children}
    </Scrollspy.Nav>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuCategoriesGridContainerProps = ComponentProps<typeof Scrollspy.Nav>;
